const CompanyRoutes = [
    {
      path: "companies",
      name: "Companies",
      component: () => import("@/pages/admin/company/ListCompaniesPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'create', on: 'Company'
        }
      },
      children: [
        {
          path: "new_company",
          name: "NewCompany",
          component: () => import("@/pages/admin/company/NewCompanyPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Company'
            }
          },
        },
        {
          path: ":id",
          name: "ShowCompany",
          component: () => import("@/pages/admin/company/ShowCompanyPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Company'
            }
          },
        },
        {
          path: ":id/users",
          name: "ShowCompanyUsers",
          component: () => import("@/pages/admin/company/ShowCompanyUsersPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Company'
            }
          },
        }
      ]
    },
  ]
  
  export default CompanyRoutes